function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_23",
  "data-name": "Layer 23"
}, React.createElement("path", {
  d: "m16 2a14 14 0 1 0 14 14 14 14 0 0 0 -14-14zm7.21 10.21-9 9a1 1 0 0 1 -.71.29h-.06a1 1 0 0 1 -.72-.38l-4-5a1 1 0 1 1 1.56-1.24l3.3 4.12 8.21-8.21a1 1 0 0 1 1.42 1.42z"
}));

var SvgChecklist = function SvgChecklist(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChecklist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checklist.20d31e72.svg";
export { ForwardRef as ReactComponent };